(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var root = document.querySelector('[data-cor-legal]');
    if (!root) return;

    var bar = root.querySelector('[data-cor-legal-bar]');
    var chapters = Array.prototype.slice.call(root.querySelectorAll('[data-cor-legal-chapter]'));
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-cor-legal-link]'));

    // progress
    if (bar) {
      var onScroll = function () {
        var rect = root.getBoundingClientRect();
        var total = rect.height - window.innerHeight;
        var scrolled = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
        var pct = total > 0 ? (scrolled / total) * 100 : 0;
        bar.style.width = pct + '%';
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    // reveal chapters (arm the animation only if we can run it)
    if (!reduce && 'IntersectionObserver' in window) {
      root.setAttribute('data-cor-legal-armed', '');
      var revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-revealed');
            revealIO.unobserve(e.target);
          }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
      chapters.forEach(function (c) { revealIO.observe(c); });
    }

    // scroll-spy
    if ('IntersectionObserver' in window && chapters.length) {
      var spyIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var id = e.target.id;
            links.forEach(function (l) {
              var on = l.getAttribute('data-cor-legal-link') === id;
              l.classList.toggle('is-active', on);
              if (on) { l.setAttribute('aria-current', 'true'); }
              else { l.removeAttribute('aria-current'); }
            });
          }
        });
      }, { rootMargin: '-30% 0px -55% 0px' });
      chapters.forEach(function (c) { spyIO.observe(c); });
    }

    // smooth click
    links.forEach(function (l) {
      l.addEventListener('click', function (ev) {
        var id = l.getAttribute('data-cor-legal-link');
        var target = document.getElementById(id);
        if (!target) return;
        ev.preventDefault();
        var top = target.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        if (!target.hasAttribute('tabindex')) { target.setAttribute('tabindex', '-1'); }
        target.focus({ preventScroll: true });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
